import { connect } from 'react-redux';
import { fetchInventoryAuditLogs } from '../../../redux/Inventory/sagas/audit-log/routines';
import {
  getIsFetching,
  getIsFetched
} from '../../../redux/Inventory/selectors/audit-log';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Inventory/selectors/audit-log/pagination';
import {
  clearInventoryAuditLogs,
  inventoryAuditLogsOnChangePage
} from '../../../redux/Inventory/actions/audit-log';
import { getAuditLogSearchQuery } from '../../../redux/Inventory/selectors/components/audit-log-search';
import InventoryAuditLogList from '../../../components/inventory/AuditLogList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getAuditLogSearchQuery(state);
  return {
    auditLogs: getCurrentPageItems(state),
    query: { ...paginationQuery, ...searchQuery },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isFetched: getIsFetched(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryAuditLogs());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryAuditLogs(query));
      else dispatch(inventoryAuditLogsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryAuditLogs());
      dispatch(fetchInventoryAuditLogs(query));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAuditLogList);
